// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/pagenavbar/index.scss
// module id = 3120
// module chunks = 13